module.exports = "https://cdn.hellotech.com/client-assets/product-discount_fe7fd7997b4d24eb2918550712d6be4e.svg";